export default __webpack_public_path__ + "static/media/createActionH3@3x.56c59fd5.png";